import { mapActions, mapGetters, mapState } from 'vuex';
import { isMarketSingle } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  props: {
    rules: String,
    dateEnd: String,
    market: {
      type: Object,
      required: true,
    },
    emphasize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('market', ['isRulesOpen']),
    ...mapGetters('app', ['isLayoutDesktop']),
    wrapperClass() {
      return {
        'market-rules__wrapper': true,
        'market-rules__wrapper--single': isMarketSingle(this.market),
      };
    },
    marginBoxClass() {
      return {
        'market-rules__box': true,
        'market-rules__box--margin': true,
      };
    },
  },
  methods: {
    ...mapActions('popup', ['setGenericSmallPopup']),
    showRulesPopup() {
      this.setGenericSmallPopup({
        name: MODALS.SMALL_MARKET_RULES,
        options: {
          title: 'The Rules',
          content: this.rules,
        },
      });
    },
  },
  mounted() {
    if (this.emphasize) this.showRulesPopup();
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-rules/market-rules.js